import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

export default class LightGallery {
  constructor(el, options = {}) {
    this.dom = {
      el,
    };

    this.lightGallery = undefined;

    this.options = {
      ...{
        plugins: [lgThumbnail],
        thumbnail: true,
        mobileSettings: {
          closable: true,
          showCloseIcon: true,
          controls: true,
        },
        download: false,
        getCaptionFromTitleOrAlt: false,
        selector: '.js-gallery-item',
        zoom: true,
      },
      ...options,
    };

    this.mount();
  }

  mount() {
    this.lightGallery = lightGallery(this.dom.el, this.options);
  }
}
